import { render } from "./sustainability-consulting.vue?vue&type=template&id=77ac30c6"
import script from "./sustainability-consulting.vue?vue&type=script&lang=js"
export * from "./sustainability-consulting.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Master\\vue-notus-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__